import axios from 'axios';
import type { Company } from '@/models/company';
import type { CompanyUser } from '@/models/companyUser';

class CompanyWebservice {
    public store(company: Company) {
        return axios.post('/companies/store', {
            name: company.name,
            description: company.description,
            email: company.email,

            phone: company.phone,
            address: company.address,
            address_addition: company.address_addition,
            postcode: company.postcode,
            city: company.city,
            country: company.country,
            setting: company.setting,
        });
    }

    public updateByMaster(company: Company) {
        return axios.post('/companies/updateByMaster', {
            id: company.id,
            name: company.name,
            description: company.description,
            email: company.email,

            phone: company.phone,
            address: company.address,
            address_addition: company.address_addition,
            postcode: company.postcode,
            city: company.city,
            country: company.country,
            setting: company.setting,
        });
    }

    public updateByAdmin(company: Company) {
        return axios.post('/companies/updateByAdmin', {
            name: company.name,
            description: company.description,

            phone: company.phone,
            address: company.address,
            address_addition: company.address_addition,
            postcode: company.postcode,
            city: company.city,
            country: company.country,
            setting: company.setting,
        });
    }

    public updateKnowledgeSettingsByAdmin(company: Company) {
        return axios.post('/companies/updateKnowledgeSettingsByAdmin', {
            setting: company.setting,
        });
    }

    public updateDynamicFieldName(dynamicFieldName: string) {
        return axios.post('/companies/updateDynamicFieldName', {
            name: dynamicFieldName,
        });
    }

    public uploadLogo(formData: FormData) {
        return axios.post('/files/uploadLogo', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }

    public deleteLogo() {
        return axios.post('/files/deleteLogo');
    }

    public sendInviteEmailToAdmin(company: Company) {
        return axios.post('/companies/sendInviteEmailToAdmin', {
            company_id: company.id,
        });
    }

    public getCompanyByUser() {
        return axios.get<Company>('/companies/getCompanyByUser');
    }

    public getCompanyById(companyId: string) {
        return axios.get<Company>('/companies/getCompanyById', {
            params: {
                company_id: companyId,
            },
        });
    }

    public getCompanyNameByToken(token: string) {
        return axios.get<Company>('/companies/getCompanyNameByToken', {
            params: {
                token,
            },
        });
    }
    public getAllUsersByCompanyId(companyId: number) {
        return axios.get<CompanyUser[]>('/companies/getAllUsersByCompanyId', {
            params: {
                company_id: companyId,
            },
        });
    }

    public cloneAllDataToCompany(
        company: Company,
        withLessons: boolean,
        withTags: boolean,
        withPMPhases: boolean,
        withPMLessons: boolean
    ) {
        return axios.post('/companies/cloneAllData', {
            company_id: company.id,
            withLessons,
            withTags,
            withPMPhases,
            withPMLessons,
        });
    }

    public remove(company: Company, confirmedCompanyName: string, password: string) {
        return axios.post('/companies/remove', {
            company_id: company.id,
            confirmed_company_name: confirmedCompanyName,
            password,
        });
    }
}

export const companyWebservice = new CompanyWebservice();
